import { render, staticRenderFns } from "./ThePersonNetworkInfoForm.vue?vue&type=template&id=89e9855a&"
import script from "./ThePersonNetworkInfoForm.vue?vue&type=script&lang=js&"
export * from "./ThePersonNetworkInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports